import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './search-coza.component.scss';
var SearchCoza = /** @class */ (function (_super) {
    tslib_1.__extends(SearchCoza, _super);
    function SearchCoza(element) {
        return _super.call(this, element) || this;
    }
    SearchCoza.prototype.init = function () {
        this.searchWrapper = this.element.querySelector(".search-coza__wrapper");
        this.searchInput = this.element.querySelector(".search-coza__search--input");
        this.searchResults = this.element.querySelector(".search-coza__results");
        this.searchingLoader = this.element.querySelector(".search-coza__results-busy");
        this.getSearchUrl();
    };
    SearchCoza.prototype.bindEvents = function () {
        var _this = this;
        if (this.searchWrapper) {
            var _closeIcon = this.searchWrapper.querySelector(".icon[data-icon=\"icon-close\"]");
            if (_closeIcon) {
                _closeIcon.addEventListener("click", function (pEvent) {
                    pEvent.stopImmediatePropagation();
                    if (_this.searchInput) {
                        _this.searchInput.value = "";
                    }
                    _this.closeResults();
                });
            }
            var _searchIcon = this.searchWrapper.querySelector(".icon[data-icon=\"icon-search-blue\"]");
            if (_searchIcon) {
                _searchIcon.addEventListener("click", function (pEvent) {
                    pEvent.stopImmediatePropagation();
                    if (_this.searchInput && _this.searchInput.value.length >= 2) {
                        _this.debounce(_this.submitSearch(), 200, false);
                    }
                });
            }
        }
        var _navbarSearch = document.querySelector(".header__secondary-bar-search");
        if (_navbarSearch) {
            _navbarSearch.addEventListener("click", function (pEvent) {
                _this.element.classList.add("search-coza--opening");
                _this.element.classList.add("search-coza--open");
                _this.expandSearch();
            });
        }
        if (this.searchInput) {
            this.searchInput.addEventListener("keypress", function (pEvent) {
                var _input = pEvent.target;
                if (_input.value.length >= 2) {
                    var _keyBoard = pEvent;
                    if ((_keyBoard.which && _keyBoard.which === 13) || (_keyBoard.keyCode && _keyBoard.keyCode === 13)) {
                        _this.debounce(_this.submitSearch(), 200, false);
                    }
                    else {
                        clearTimeout(_this.timer);
                        _this.timer = setTimeout(function () {
                            _this.debounce(_this.postSearch(), 200, false);
                        }, 500);
                    }
                }
            });
        }
        window.addEventListener("resize", this.debounce(function () {
            if (_this.element.classList.contains("search--open")) {
                _this.expandSearch();
            }
        }, 50, false));
    };
    SearchCoza.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    };
    SearchCoza.prototype.getSearchUrl = function () {
        var _this = this;
        var _headers = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest',
                'Analytics-User': this.analyticsService.getDtmVisitorID(),
            }
        };
        this.http.getHeaders("/file_source/assets/components/search_coza/commerceurls.json", _headers).then(function (pUrls) {
            if (pUrls.data) {
                if (pUrls.data.searchSuggestions) {
                    var _hiddenSuggestionsUrl = document.createElement("input");
                    _hiddenSuggestionsUrl.type = "hidden";
                    _hiddenSuggestionsUrl.name = "searchSuggestions";
                    _hiddenSuggestionsUrl.value = pUrls.data.searchSuggestions;
                    _this.element.appendChild(_hiddenSuggestionsUrl);
                    _this.hiddenSearchSuggestions = _this.element.querySelector("input[name=searchSuggestions]");
                }
                if (pUrls.data.searchPage) {
                    var _hiddenResultsUrl = document.createElement("input");
                    _hiddenResultsUrl.type = "hidden";
                    _hiddenResultsUrl.name = "searchResults";
                    _hiddenResultsUrl.value = pUrls.data.searchPage;
                    _this.element.appendChild(_hiddenResultsUrl);
                    _this.hiddenSearchResults = _this.element.querySelector("input[name=searchResults]");
                }
            }
        }).catch(function (pError) {
            console.log(pError);
        });
    };
    SearchCoza.prototype.postSearch = function () {
        var _this = this;
        if (this.searchInput.value.length < 2) {
            if (this.searchResults) {
                if (this.searchResults.classList.contains("search-coza__results--open")) {
                    this.searchResults.classList.add("search-coza__results--closing");
                }
            }
        }
        if (this.searchInput.value.length >= 2) {
            var _resultsContent_1 = this.searchResults.querySelector(".search-coza__results-content");
            if (_resultsContent_1) {
                _resultsContent_1.innerHTML = "";
            }
            this.searchingLoader.classList.remove("search-coza__results-busy--hide");
            this.searchResults.classList.add("search-coza__results--open");
            this.searchResults.classList.remove("search-coza__results--closing");
            if (this.hiddenSearchSuggestions) {
                var _headers = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'Access-Control-Allow-Origin': '*',
                        'X-Requested-With': 'XMLHttpRequest',
                        'Analytics-User': this.analyticsService.getDtmVisitorID()
                    }
                };
                this.http.getHeaders(this.hiddenSearchSuggestions.value + "?q=" + this.searchInput.value, _headers).then(function (pResponse) {
                    _resultsContent_1.innerHTML = "";
                    _this.searchingLoader.classList.add("search-coza__results-busy--hide");
                    _this.handleHtml(pResponse.data, _resultsContent_1);
                }).catch(function (pError) {
                    _resultsContent_1.innerHTML = "";
                    var _error = document.createElement("p");
                    _error.innerText = "Oops, an error has occurred. Please try again later.";
                    _resultsContent_1.appendChild(_error);
                    _this.searchingLoader.classList.add("search-coza__results-busy--hide");
                });
            }
            else {
                _resultsContent_1.innerHTML = "";
                var _error = document.createElement("p");
                _error.innerText = "Oops, an error has occurred. Please try again later.";
                _resultsContent_1.appendChild(_error);
                this.searchingLoader.classList.add("search-coza__results-busy--hide");
            }
        }
    };
    SearchCoza.prototype.handleHtml = function (pHtml, pSearchResults) {
        var str2DOMElement = function (html) {
            var frame = document.createElement('iframe');
            frame.style.display = 'none';
            document.body.appendChild(frame);
            frame.contentDocument.open();
            frame.contentDocument.write(html);
            frame.contentDocument.close();
            var elBody = frame.contentDocument.body;
            document.body.removeChild(frame);
            return elBody;
        };
        var _domElem = pSearchResults;
        var el = str2DOMElement(pHtml);
        _domElem.appendChild(el.children[0]);
    };
    SearchCoza.prototype.submitSearch = function () {
        this.closeResults();
        if (this.hiddenSearchResults) {
            location.href = this.hiddenSearchResults.value + "?q=" + encodeURI(this.searchInput.value);
        }
        else {
            location.href = "/southafrica/personal/search?q=" + encodeURI(this.searchInput.value);
        }
    };
    SearchCoza.prototype.closeResults = function () {
        var _this = this;
        this.searchResults.classList.add("search-coza__results--closing");
        setTimeout(function () {
            _this.element.classList.add("search-coza--closing");
            setTimeout(function () {
                _this.element.classList.remove("search-coza--open");
                _this.element.classList.remove("search-coza--closing");
                _this.searchResults.classList.remove("search-coza__results--open");
                _this.searchResults.classList.remove("search-coza__results--closing");
            }, 350);
        }, 200);
    };
    SearchCoza.prototype.expandSearch = function () {
        var _this = this;
        setTimeout(function () {
            _this.element.classList.remove("search-coza--opening");
        }, 350);
        if (this.searchInput) {
            this.searchInput.focus();
        }
    };
    SearchCoza.prototype.validURL = function (str) {
        var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (pattern.test(str)) {
            return true;
        }
        return false;
    };
    SearchCoza.prototype.getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    return SearchCoza;
}(Base));
export { SearchCoza };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/search-coza/search-coza.component.ts
// module id = 975
// module chunks = 0